var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('indicator-value-table');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { EntityValue } from './entity-value';
import { useLang } from '../../hooks/use-lang';
import { IndicatorValueValue } from './indicator-value-value';
export var IndicatorValueTableDefaultProps = {
  values: [],
  indicatorCellLabel: "Indicator"
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 800px;\n  "], ["\n    width: 100%;\n    max-width: 800px;\n  "])))
});
var HeadStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeadRowStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RowStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: 2px;\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    ", ";\n    padding-bottom: 2px;\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme.H_DOT_BG_END('line-mid', 1.5))
});
var CellStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    padding-left: ", ";\n    padding-right: 0;\n    width: 70%;\n    text-align: right; \n    white-space: nowrap;\n  "], ["\n    padding: ", ";\n    padding-left: ", ";\n    padding-right: 0;\n    width: 70%;\n    text-align: right; \n    white-space: nowrap;\n  "])), theme.UNIT(3), theme.UNIT(4))
});
var HeadCellStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n    width: 40%;\n    white-space: wrap;\n    padding-left: 0;\n    text-align: left;\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n  "], ["\n    ", ";\n    width: 40%;\n    white-space: wrap;\n    padding-left: 0;\n    text-align: left;\n    padding-bottom: ", ";\n    border-bottom: 1px solid ", ";\n  "])), CellStyles, theme.UNIT(2), theme.COLOR('line-mid'))
});
var ValueHeadCellStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), HeadCellStyles)
});
var RowHeadCellStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    padding-left: 0;\n  "], ["\n    ", ";\n    padding-left: 0;\n  "])), CellStyles)
});
var IndicatorStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IndicatorValueStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.table(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled.thead.attrs(cls.attr('head'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  HeadRow: styled.tr.attrs(cls.attr('head-row'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeadRowStyles),
  HeadCell: styled.th.attrs(cls.attr('head-cell'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), HeadCellStyles),
  ValueHeadCell: styled.th.attrs(cls.attr('value-head-cell'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ValueHeadCellStyles),
  Label: styled(CellLabel)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Body: styled.tbody.attrs(cls.attr('body'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Row: styled.tr.attrs(cls.attr('row'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  RowHeadCell: styled.th.attrs({
    scope: 'row'
  })(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), RowHeadCellStyles),
  Cell: styled.td.attrs(cls.attr('cell'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Indicator: styled(EntityValue)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), IndicatorStyles),
  IndicatorValue: styled(IndicatorValueValue)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), IndicatorValueStyles)
};
export var IndicatorValueTable = function IndicatorValueTable(props) {
  var className = props.className,
      values = props.values,
      indicatorCellLabel = props.indicatorCellLabel,
      onChange = props.onChange;
  var t = useLang();

  if (!values.length) {
    return null;
  }

  return React.createElement(My.Container, {
    cellSpacing: 0,
    className: cls.name(className)
  }, React.createElement(My.Head, null, React.createElement(My.HeadRow, null, React.createElement(My.HeadCell, {
    colSpan: 2
  }, React.createElement(My.Label, null, t(indicatorCellLabel), ":")))), React.createElement(My.Body, null, values.map(function (valueItem) {
    var indicator = valueItem.indicator,
        value = valueItem.value;

    if (!indicator) {
      // indicators are required
      return null;
    }

    var unit = indicator.unit;
    return React.createElement(My.Row, {
      key: valueItem.id
    }, React.createElement(My.RowHeadCell, null, React.createElement(My.Indicator, {
      imageSize: 20,
      entity: indicator,
      name: indicator.title,
      variant: "name"
    })), React.createElement(My.Cell, null, React.createElement(My.IndicatorValue, {
      value: value,
      unit: unit
    })));
  }), React.createElement(My.Row, null)));
};
IndicatorValueTable.defaultProps = IndicatorValueTableDefaultProps;
IndicatorValueTable.cls = cls; // constants to simulate indicators

export var UNIT_SQ_KM = {
  id: 'sqkm',
  name: 'Square Kilometres',
  suffix: 'km2',
  __typename: 'Unit'
};
export var UNIT_PER_SQ_KM = {
  id: 'sqkm',
  name: 'Per Square Km',
  suffix: '/ km2',
  __typename: 'Unit'
};
export var UNIT_NUMBER = {
  id: 'number',
  name: 'Number',
  __typename: 'Unit'
};
export var UNIT_PERCENT = {
  id: 'percent',
  name: 'Percent',
  suffix: '%',
  __typename: 'Unit'
};
export var UNIT_USD = {
  id: 'usd',
  name: 'US Dollars',
  prefix: '$',
  suffix: 'USD',
  __typename: 'Unit'
};
export var UNIT_AUD = {
  id: 'aud',
  name: 'Australian Dollars',
  prefix: '$',
  suffix: 'AUD',
  __typename: 'Unit'
};
export var INDICATOR_AREA_IN_SQ_KM = {
  id: "area-in-square-km",
  name: 'Area',
  __typename: 'Indicator',
  unit: UNIT_SQ_KM
};
export var INDICATOR_POPULATION = {
  id: "population",
  name: 'Population (Estimated)',
  __typename: 'Indicator',
  unit: UNIT_NUMBER
};
export var INDICATOR_POPULATION_CITY = {
  id: "population-city",
  name: 'Population City (Estimated)',
  __typename: 'Indicator',
  unit: UNIT_NUMBER
};
export var INDICATOR_DENSITY = {
  id: "density",
  name: 'Density',
  __typename: 'Indicator',
  unit: UNIT_PER_SQ_KM
};
export var INDICATOR_GENDER_SPLIT = {
  id: "gender-split",
  name: 'Gender Split',
  __typename: 'Indicator',
  unit: UNIT_NUMBER
};
export var INDICATOR_MEDIAN_AGE = {
  id: "median-age",
  name: 'Median Age',
  __typename: 'Indicator',
  unit: UNIT_NUMBER
};
export var INDICATOR_AGE_0_TO_19 = {
  id: "age-0-19",
  name: 'Age (0-19)',
  __typename: 'Indicator',
  unit: UNIT_PERCENT
};
export var INDICATOR_AGE_20_TO_49 = {
  id: "age-20-49",
  name: 'Age (20-49)',
  __typename: 'Indicator',
  unit: UNIT_PERCENT
};
export var INDICATOR_AGE_50_PLUS = {
  id: "age-50-plus",
  name: 'Age (50+)',
  __typename: 'Indicator',
  unit: UNIT_PERCENT
};
export var INDICATOR_GDP = {
  id: "gdp",
  name: 'GDP',
  __typename: 'Indicator',
  unit: UNIT_USD
};
export var INDICATOR_PER_CAPITA_INCOME = {
  id: "per-capita-income",
  name: 'Per Capita Income',
  __typename: 'Indicator',
  unit: UNIT_USD
};
export var INDICATOR_MEDIAN_HOUSEHOLD_INCOME = {
  id: "median-household-income",
  name: 'Median Household Income',
  __typename: 'Indicator',
  unit: UNIT_USD
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;